import { MessageCircle } from "lucide-react";

export function ChatEmptyState() {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center px-6">
      <div className="h-16 w-16 rounded-2xl bg-muted/40 flex items-center justify-center mb-4">
        <MessageCircle className="h-8 w-8 text-muted-foreground/30" />
      </div>
      <p className="text-base font-medium text-foreground">
        Start the conversation
      </p>
      <p className="text-sm text-muted-foreground mt-1.5 leading-relaxed">
        Comments and activity for this document will appear here.
      </p>
    </div>
  );
}
